import { Tag } from "@blueprintjs/core";
import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ActionIcon, Menu, ScrollArea } from "@mantine/core";

import { Repo } from "@pages/projects/types";

type Props = {
  repos: Repo[];
  projectsWithoutPolicy: Repo[];
  onRemove: (repo: Repo) => void;
  onAdd: (repo: Repo) => void;
};

export const ProjectsSummaryPanel: React.FC<Props> = ({
  repos,
  projectsWithoutPolicy,
  onRemove,
  onAdd,
}) => {
  return (
    <>
      {repos.map((repo) => (
        <Tag
          intent="primary"
          large
          style={{ marginRight: "0.5em", marginBottom: "0.5em" }}
          onRemove={() => {
            onRemove(repo);
          }}
        >
          {repo.name}
        </Tag>
      ))}
      <Menu withinPortal position="right-start">
        <Menu.Target>
          <ActionIcon variant="subtle">
            <FontAwesomeIcon
              color={"var(--global-purple)"}
              icon={faPlusCircle}
            />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <ScrollArea sx={{ height: 300 }}>
            {projectsWithoutPolicy.length === 0 ? (
              <Menu.Item disabled>Policy assigned to all projects</Menu.Item>
            ) : (
              projectsWithoutPolicy.map((repo) => (
                <Menu.Item onClick={() => onAdd(repo)}>{repo.name}</Menu.Item>
              ))
            )}
          </ScrollArea>
        </Menu.Dropdown>
      </Menu>
    </>
  );
};
